"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Badge.css");
var BadgeProps_1 = require("./BadgeProps");
var BadgeStylesMap_1 = require("./BadgeStylesMap");
var Label_1 = require("../Label/Label");
var LabelProps_1 = require("../Label/LabelProps");
var utils_1 = require("../../../utils/utils");
var Badge = /** @class */ (function (_super) {
    __extends(Badge, _super);
    function Badge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Badge.prototype.render = function () {
        var classes = [styles.badge, this.getColor(this.props.options)];
        var textData = {
            text: this.props.data.text.toUpperCase(),
        };
        var textOptions = {
            size: LabelProps_1.LabelSizes.EYEBROWSMALL,
        };
        return (React.createElement("div", { "data-test-id": this.props.testId, className: classes.join(' ') },
            React.createElement(Label_1.default, { testId: utils_1.default(this.props.testId, 'Label'), data: textData, options: textOptions })));
    };
    Badge.prototype.getColor = function (options) {
        return BadgeStylesMap_1.colorsMap.get(options.color);
    };
    Badge.defaultProps = {
        options: {
            color: BadgeProps_1.BadgeColors.BLACK,
        },
    };
    return Badge;
}(React.Component));
exports.default = Badge;
//# sourceMappingURL=Badge.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Badge/Badge.js
// module id = 1036
// module chunks = 8